import React from 'react'
import { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import PinchZoomPan from "react-responsive-pinch-zoom-pan";
import { ContentLanding } from "./ContentLanding"

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

export const BalloonContent = (props) => {
  const string = props.stringToRet;
  const telescopeEye = React.createRef();
  const telescopeLine = React.createRef();

  const binaryCode = '01110011 01100011 01101000 01101001 01100001 01101110 01110100 01101111 00101110 00100000 01110011 01100111 01100001 01101110 01100011 01101001 01101111 00100000 01110000 01100001 01110010 01100001 01100011 01100001 01100100 01110101 01110100 01100101 00101110 00100000 01100011 01101111 01101101 01110000 01110101 01110100 01100101 01110010 00100000 01100100 01101001 00100000 01100010 01101111 01110010 01100100 01101111 00100000 01101001 01101110 00100000 01110100 01101001 01101100 01110100 00101110 00100000 01100001 01100011 01100011 01100101 01101110 01110011 01101001 01101111 01101110 01100101 00100000 01110010 01100101 01110100 01110010 01101111 01110010 01100001 01111010 01111010 01101001 00100000 01110000 01100101 01110010 00100000 00110011 00100000 01110011 01100101 01100011 01101111 01101110 01100100 01101001 00101110';

  const restartAnimation = (e) => {
    telescopeEye.current.classList.remove("telescopeEye");
    void telescopeEye.current.offsetWidth;
    telescopeEye.current.classList.add("telescopeEye");

    telescopeLine.current.classList.remove("telescopeLine");
    void telescopeLine.current.offsetWidth;
    telescopeLine.current.classList.add("telescopeLine");
  }

  return (
    <>


      {(string === 'b_exit_room1') && (
        <>
          <h3>BEN FATTO!</h3>
          <p>Hai risolto il primo enigma</p>
          <button className="btn btn-danger">PROSEGUI</button>
        </>
      )}

      {(string === 'b_exit_room2') && (
        <>
          <h3>BEN FATTO!</h3>
          <p>Hai risolto l'enigma</p>
          <button className="btn btn-danger">PROSEGUI</button>
        </>
      )}

      {(string === 'b_exit_room3') && (
        <>
          <h3>BEN FATTO!</h3>
          <p>Hai risolto l'enigma</p>
          <button className="btn btn-danger">PROSEGUI</button>
        </>
      )}

      {(string === 'b_exit_room4') && (
        <>
          <h3>BEN FATTO!</h3>
          <p>Hai risolto l'enigma</p>
          <button className="btn btn-danger">PROSEGUI</button>
        </>
      )}

      {(string === 'b_exit_room5') && (
        <>
          <h3>BEN FATTO!</h3>
          <p>Hai risolto l'enigma</p>
          <button className="btn btn-danger">PROSEGUI</button>
        </>
      )}

      {(string === 'b_exit_room6') && (
        <>
          <h3>BEN FATTO!</h3>
          <p>Hai risolto l'enigma</p>
          <button className="btn btn-danger">PROSEGUI</button>
        </>
      )}

      {/* ROOM 1 */}
      {(string === 'b_preintro_room1') && (
        <>
          <h3>ULTIMATUM ALLA TERRA</h3>
          <p>Ti ringraziamo per aver risposto al nostro appello.<br />
          Abbiamo bisogno del tuo aiuto.<br />
          <strong>Margherita Hacker</strong>, celebre astrofisica e
          appassionata di restauro di strumenti antichi,<br />ha rinvenuto un messaggio parzialmente
          illeggibile proveniente dal passato il cui testo<br />risuona come un avvertimento all’umanità per
          le future esplorazioni di Marte.</p>
          <p>Marte nasconde una minaccia!</p>
          <p>Hai <strong>90 minuti</strong> di tempo per aiutare Margherita Hacker a decifrare il messaggio e <strong>salvare la Terra e l’Umanità</strong>.</p>
          <p><strong>Fai presto!</strong></p>
          <button className="btn btn-danger">INIZIA</button>
        </>
      )}

      {(string === 'b_intro_room1') && (
        <>
          <h3>8 AGOSTO 2016 - LABORATORIO DI RESTAURO DI MARGHERITA HACKER</h3>
          <p>Le ore della notte sono le migliori per concentrarsi nel restauro di uno strumento astronomico antico.</p>
          <button className="btn btn-danger">CONTINUA</button>
        </>
      )}

      {(string === 'b_marge1a_room1') && (
        <p>Ciao, sono <strong>Margherita Hacker</strong>. Qualche mese fa, dopo preparativi che mi sono parsi lunghissimi,
        ho finalmente iniziato il lavoro di restauro del celebre telescopio <strong>Merz-Repsold</strong>. È un incarico che mi emoziona...</p>
      )}
      {(string === 'b_marge1b_room1') && (
        <p>Grazie a questo telescopio <strong>Giovanni Virginio Schiaparelli</strong>, direttore dell’<strong>osservatorio
        astronomico di Brera</strong> a Milano fino al 1900, ha osservato e rappresentato la geografia del
        pianeta Marte <strong>come mai nessuno aveva fatto in precedenza!</strong></p>
      )}
      {(string === 'b_marge1c_room1') && (
        <p>Questa notte però, mentre smontavo alcuni elementi meccanici del telescopio per ripulirli,
        ho rinvenuto all’interno di una piccola nicchia un <strong>bigliettino</strong> firmato da Schiaparelli in persona,
        datato 1890.</p>
      )}
      {(string === 'b_marge1d_room1') && (
        <p>Il messaggio è <strong>parzialmente illeggibile</strong>. Il testo, però,
        risuona come un <strong>avvertimento all’umanità</strong> per le future esplorazioni di Marte.</p>
      )}
      {(string === 'b_lettera_room1') && (
        <div style={{ width: '100%', height: '100%' }}>
            <PinchZoomPan position="center">
              <img src={require('../assets/images/lettera_schiaparelli.png')} alt="" />
            </PinchZoomPan>
        </div>
      )}
      {(string === 'b_marge2a_room1') && (
        <p>Questo testo mi ha lasciato addosso una grande inquietudine: è carico di parole da non prendere
        alla leggera: <strong>guerre</strong>, <strong>pazzi abitanti</strong>, <strong>nuocere</strong>, <strong>nemico</strong>. L’unica cosa a cui riesco a pensare
        sono le sue osservazioni di Marte, realizzate con questo telescopio.</p>
      )}
      {(string === 'b_marge2b_room1') && (
        <p><strong>Che cosa ci voleva dire Schiaparelli?</strong> Da che cosa dobbiamo guardarci? Se è davvero un avvertimento,
        allora Schiaparelli deve aver lasciato altri indizi. Era un ricercatore meticoloso e prudente: non può
        aver nascosto un biglietto senza che vi fosse un piano sotto. Ma quale? <strong>Devono esserci altri indizi</strong>. <strong>Devo trovarli</strong>.</p>
      )}

      {(string === 'b_marge2c_room1') && (
        <p>Ho trovato il biglietto all’interno di uno dei componenti del telescopio, ma non ricordo quale.
        Il suo <strong>codice di inventario</strong> sarà la tua <strong>password</strong> per proseguire.</p>
      )}


      {(string === 'b_bacheca_room1') && (
        <Swiper modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={1}
          loop = {true}
          pagination={{
            type: "bullets",
            clickable: "true"
          }}
          autoplay={false}
          navigation={true}
          onBeforeInit={(swiper) => {
            return;
          }}
        >
          <SwiperSlide>
            <img src={require('../assets/images/components/image1.png')} alt="Componenti 1" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={require('../assets/images/components/image2.png')} alt="Componenti 2" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={require('../assets/images/components/image3.png')} alt="Componenti 3" />
          </SwiperSlide>
        </Swiper>
      )}

      {(string === 'b_computer_room1') && (
        <>
          <a target="_blank" className="linkedImage" href="https://convert.town/ascii-to-text">
            <img src={require('../assets/images/componenti-mac.gif')} alt="" />
          </a>
        </>
      )}

      {(string === 'b_help_room1') && (
        <>
          <p>Attenzione: puoi utilizzare quanti aiuti desideri, ma tieni presente che alla fine della partita gli aiuti sono convertiti in penalità:</p>
          <p>aiuto di tipo 1 = una penalità<br />
          aiuto di tipo 2 = due penalità<br />
          aiuto di tipo 3 = tre penalità</p>
          <p>Pensa bene a quanti aiuti vuoi utilizzare!</p>
        </>
      )}


      {/* ROOM 2 */}

      {(string === 'b_intro_room2') && (
        <>
          <h3>12 AGOSTO 2016 – CUPOLA DELL’OSSERVATORIO DI BRERA</h3>
          <p>Le mie ricerche proseguono all’interno della cupola dell’Osservatorio di Brera a Milano.
          Qui trovo il primo dei due telescopi rifrattori fatti installare da Giovanni Virginio Schiaparelli
          durante la sua lunga direzione dell’Osservatorio, dal 1862 al 1900. Con questo telescopio,
          a partire dal 1877 l’astronomo fece le sue famose osservazioni della topografia del pianeta Marte.</p>
          <button className="btn btn-danger">CONTINUA</button>
        </>
      )}

      {(string === 'b_marge1a_room2') && (
        <p>Sapevo che la cupola non mi avrebbe delusa: credo di aver fatto importanti passi avanti.</p>
      )}
      {(string === 'b_marge1b_room2') && (
        <><p>All'interno  di un cassetto del secretaire, nel doppio fondo, ho trovato una lettera. Per leggerla, dovrai prima dirmi la password.</p>
        <p><strong>La password è il ... più vicino.</strong></p>
        </>
      )}
      {(string === 'b_marge1c_room2') && (
        <p>Mentre perlustravo la cupola ho guardato distrattamente all’interno del telescopio e ho osservato con i miei occhi un fatto inquietante…</p>
      )}

      {(string === 'b_marge2a_room2') && (
        <p>Mi sono domandata poi verso che direzione puntasse il telescopio in questa cupola.</p>
      )}

      {(string === 'b_marge3a_room2') && (
        <p>Per chiudere il cerchio, ho controllato sulle Maps dove fosse posizionata questa cupola.
        Ho la soluzione!</p>
      )}



      {(string === 'b_marge4a_room2') && (
        <p>La lettera che ho trovato all’interno del doppio fondo è firmata nientepopodimeno che da <strong>Napoleone Bonaparte</strong>!<br />
        È datata 12 agosto 1796. Può essere un caso che oggi sia il 12 agosto? Esattamente 220 anni dopo…</p>
      )}
      {(string === 'b_marge4b_room2') && (
        <p>Fu spedita da Napoleone al generale Augereau, durante l’occupazione di Verona. Gli raccomanda la persona e le proprietà del Signor Cagnoli, un astronomo veronese che possedeva un osservatorio astronomico personale, dotato di diversi strumenti di pregio.</p>
      )}
      {(string === 'b_marge5a_room2') && (
        <p>Cercando all’interno di un secondo cassetto del secretaire ho trovato una scatolina di latta decorata, molto femminile, chiusa con un lucchetto a <strong>combinazione di 4 lettere</strong>.</p>
      )}
      {(string === 'b_marge5b_room2') && (
        <p>La parola della combinazione è sul <strong>"piede di guerra"</strong>.</p>
      )}

      {(string === 'b_marge6a_room2') && (
        <p>Sembra che i segreti della cupola non finiscano mai.<br />
        Aperta la scatolina, un’altra lettera. Questa volta di <strong>Elsa Schiaparelli</strong>, la nipote dell’astronomo, che diventerà una <strong>stilista rivoluzionaria nel campo della moda</strong>.</p>
      )}
      {(string === 'b_marge6b_room2') && (
        <p>La lettera è datata <strong>20 giugno 1908</strong>, Elsa ha 17 anni e manda i saluti allo zio. Ma conosco fin troppo bene Schiaparelli per immaginare che la storia non finisca tutta qui.</p>
      )}

      {(string === 'b_marge7a_room2') && (
        <p>Elsa e lo zio Virginio hanno utilizzato una <strong>parola chiave per comunicarsi qualcosa</strong>. Quando lo zio fece osservare a Elsa il cosmo attraverso il suo telescopio, in lei nacque un amore per l’astronomia che poi trasferì nel suo lavoro. </p>
      )}
      {(string === 'b_marge7b_room2') && (
        <>
          <p>Per continuare le indagini avrai bisogno di scoprire una nuova password. Ascoltami bene:</p>
          <p><strong>«Il capriccioso in quei giorni in una costellazione transitava. Ella, nella futura «Maison Schiaparelli», una collana d’oro alla costellazione ispirava. Il nome della collana è la tua porta d’accesso che ti mancava.»</strong></p>
        </>
    )}
      {(string === 'b_telescopio_room2') && (
        <>
          <div className="telescopeLine" ref={telescopeLine} />
          <button onClick={restartAnimation} className="restartAnimation">Rivedi animazione</button>

          <div className="telescopeEye" ref={telescopeEye}>
            <img  src={require('../assets/images/telescopio.png')} alt="telescopio view" />
            <div className="telescopeMorse" />
          </div>
        </>
      )}
      {(string === 'b_cellulare_room2') && (
        <a target="_blank" className="linkedImage" href="https://www.google.com/maps/@45.4720109,9.1891711,175m/data=!3m1!1e3">
          <img  src={require('../assets/images/musei-maps.png')} alt="telescopio view" />
        </a>
      )}
      {(string === 'b_visore_room2') && (
        <p>Controlla l'orientamento del telescopio rispetto alla cupola. Guarda nel visore <a target="_blank" href="http://www.brera.inaf.it/PanoramicheBrera/cupola_Schiaparelli/app-files/">VAI ></a></p>
      )}

      {(string === 'b_lettera_room2') && (
        <div style={{ width: '100%', height: '100%' }}>
            <PinchZoomPan position="center">
            <img src={require('../assets/images/lettera_napoleone.jpg')} alt="lettera Napoleone" />
            </PinchZoomPan>
        </div>
      )}

      {(string === 'b_scatolina_room2') && (
        <div style={{ width: '100%', height: '100%' }}>
          <PinchZoomPan position="center">
            <img src={require('../assets/images/lettera_elsa.png')} alt="lettera Napoleone" />
          </PinchZoomPan>
        </div>
      )}


      {/* ************************** */ }
      {/* ********* ROOM 3 ********* */}
      {/* ************************** */ }

      {(string === 'b_intro_room3') && (
        <>
          <h3>18 agosto 2016 – Osservatorio di Brera, archivio storico</h3>
          <p>Le ricerche continuano. Sono all'Archivio Storico dell'Osservatorio di Brera.</p>
          <button className="btn btn-danger">CONTINUA</button>
        </>
      )}

      {(string === 'b_marge1a_room3') && (
        <p>Voglio dare un’occhiata ai diari <strong>manoscritti di Schiaparelli</strong> che sono conservati qui.</p>
      )}
      {(string === 'b_marge1b_room3') && (
        <p>Contengono le osservazioni astronomiche originali: calcoli osservativi, appunti sugli oggetti osservati e soprattutto i <strong>disegni di Marte</strong> schizzati durante l'osservazione diretta. <strong>Che contengano qualche indizio?</strong></p>
      )}
      {(string === 'b_marge1c_room3') && (
        <p>Certo che è così! Non poteva essere altrimenti! Dove nascondere un indizio su Marte se non in un meraviglioso <strong>disegno di Marte del 25 giugno 1890</strong>. Per venirne a capo però, ti consiglio di confrontarlo con l’<strong>intera mappa di Marte</strong>, che ho ben protetto con una password.</p>
      )}

      {(string === 'b_diario_room3') && (
        <div style={{ width: '100%', height: '100%' }}>
          <PinchZoomPan position="center">
            <img src={require('../assets/images/diario.jpg')} alt="Mappa Marte" />
          </PinchZoomPan>
        </div>
      )}

      {(string === 'b_marge2a_room3') && (
        <p><strong>Il nome che voglio, stampatelo bene in testa, è quello di colui che lì è dimezzato.</strong></p>
      )}
      {(string === 'b_marge2b_room3') && (
        <>
          <p>Per venirne a capo però, ti consiglio di confrontarlo con l’intera mappa di Marte, che ho ben protetto con una password.</p>
          <p><strong>«Il nome che voglio, stampatelo bene in testa, è quello del Re dimezzato.»</strong></p>
        </>
      )}

      {(string === 'b_marge3a_room3') && (
        <p>Questa è la mappa di Marte (areografia) <strong>disegnata da Schiaparelli</strong> nell’ultima osservazione del 1890, in cui assegna ai vari luoghi del pianeta nomi tratti dall'<strong>antica geografia e mitologia</strong>, attingendo alla sua vasta e profonda cultura classica.</p>
      )}

      {(string === 'b_marge3b_room3') && (
        <>
          <p>Ecco che cosa ho scoperto, dunque. Te lo voglio dire in questo modo: la tua prossima tappa avrà Elleniche coordinate.</p>
          <p><strong>«Ci vedremo là su Marte dove si incontrano il 14° Re di Argo, il Dio del fuoco e l’alta catena montuosa dell'Attica»</strong></p>
        </>
      )}

      {(string === 'b_map_room3') && (
        <div style={{ width: '100%', height: '100%' }}>
          <PinchZoomPan position="center">
            <img src={require('../assets/images/mars_zoom.png')} alt="Mappa Marte" />
          </PinchZoomPan>
        </div>

      )}

      {(string === 'b_marge4a_room3') && (
        <p>Ecco che cosa ho scoperto, dunque. Te lo voglio dire in questo modo: la tua prossima tappa avrà Elleniche coordinate.</p>
      )}
      {(string === 'b_marge4b_room3') && (
        <p>«Ci vedremo là su Marte dove si incontrano il 14° Re di Argo, il Dio del fuoco e l’alta catena montuosa dell'Attica»</p>
      )}

      {/* ************************** */ }
      {/* ********* ROOM 4 ********* */}
      {/* ************************** */ }

      {(string === 'b_intro_room4') && (
        <>
          <h3>19 ottobre 2016 – Tragedia su Marte: il lander dell’ESA si schianta al suolo!</h3>
          <p>Non posso credere ai miei occhi. Mentre documentavo sul mio canale Instagram la missione ExoMars dell’ESA (European Space Agency), il lander che doveva posarsi dolcemente sul suolo di Marte, si è invece schiantato!
Pare che abbia perso il controllo dell’assetto di volo, si son persi i contatti e ora chissà che cosa è rimasto.</p>

<p>Ma c’è di più. Sapete come era stato chiamato quel lander? Schiaparelli. Un modo per rendere onore al grande astronomo, capite?</p>

<p>Delle due l’una: o lo Schiaparelli lander non vale un occhio dello Schiaparelli in carne ed ossa, oppure, Schiaparelli astronomo ci ha mandato un avvertimento tramite il lander: state lontani da Marte.
Non avrei dovuto sospendere le ricerche, l’estate scorsa. E ora mi sto dannando per quella scelta.</p>
          <button className="btn btn-danger">CONTINUA</button>
        </>
      )}

      {(string === 'b_marge1a_room4') && (
        <p>Sarebbe una follia, lo ripeto. Eppure, mi sono messa a studiare le informazioni rilasciate dall'<strong>ESA</strong> sul caso e…<br />
        riguardando le immagini che ho postato <strong>sul mio canale Instagram</strong> credo proprio di aver trovato un indizio!</p>
      )}

      {(string === 'b_marge1b_room4') && (
        <>
          <p>Per accedere al dossier dell’Ente Spaziale Europeo, devi prima trovare la password per sbloccare il fascicolo…</p>
        </>
      )}

      {(string === 'b_cellulare_room4') && (
        <Swiper modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={1}
          loop = {true}
          pagination={{
            type: "bullets",
            clickable: "true"
          }}
          autoplay={false}
          navigation={true}
          onBeforeInit={(swiper) => {
            return;
          }}
        >
          <SwiperSlide>
            <img src={require('../assets/images/instagram/insta-1.jpg')} alt="instagram 1" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={require('../assets/images/instagram/insta-2.jpg')} alt="instagram 2" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={require('../assets/images/instagram/insta-3.jpg')} alt="instagram 3" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={require('../assets/images/instagram/insta-4.jpg')} alt="instagram 4" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={require('../assets/images/instagram/insta-5.jpg')} alt="instagram 5" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={require('../assets/images/instagram/insta-6.jpg')} alt="instagram 6" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={require('../assets/images/instagram/insta-7.jpg')} alt="instagram 7" />
          </SwiperSlide>
        </Swiper>
      )}

      {(string === 'b_marge2a_room4') && (
        <p>È proprio questo l’indizio che cercavo! La causa principale dell’impatto sarebbe stato un difetto nelle misurazioni
        dell’<strong>IMU (Unità di Misura Inerziale)</strong>, lo strumento che misura l’assetto e l’accelerazione della sonda!</p>
      )}

      {(string === 'b_marge2b_room4') && (
        <>
          <p>Per completare il puzzle non mi resta che interpretare i dati del computer di bordo e capire la causa del problema.</p>
          <p><strong>Traduci e poi ordina nel modo corretto le istruzioni del software.</strong></p>
        </>
      )}

      {(string === 'b_schermo_room4') && (
        <>
          <p>{binaryCode}</p>
          <button className="btn btn-danger" onClick={() => {navigator.clipboard.writeText(binaryCode)}}>Copia codice</button>
        </>
      )}

      {(string === 'b_marge3a_room4') && (
        <p>Bingo! Ora so cosa è successo: l’IMU, rivelando improvvise rotazioni della sonda ha inviato troppi dati al computer di bordo che è andato in tilt!</p>
      )}

      {(string === 'b_marge3b_room4') && (
        <p>A quel punto, pensando di trovarsi a pochi metri da terra ha sganciato il paracadute e acceso i razzi per soli 3 secondi anziché 30! La sonda è precipitata in caduta libera per più di 3 km!</p>
      )}

      {(string === 'b_marge3c_room4') && (
        <p>Non c’entrano Marte o i marziani! E, almeno questo, non è un indizio che ci manda Schiaparelli dal passato. Sarebbe stato troppo: mi sto rendendo conto che il pensiero di quel presunto messaggio mi sta facendo male. È meglio che lasci perdere: non voglio perderci più tempo.</p>
      )}

      {/* ************************** */ }
      {/* ********* ROOM 5 ********* */}
      {/* ************************** */ }

      {(string === 'b_intro_room5') && (
        <>
          <h3>18 Settembre 2017 – Museo Nazionale della Scienza e della Tecnologia Leonardo da Vinci</h3>
          <p>È trascorso quasi un anno dallo schianto dello
          Schiaparelli lander. Da quel giorno è come se mi fossi schiantata anch’io.<br />
          Nel frattempo, ho approfittato per terminare il restauro del telescopio che
          ora è esposto nella sezione Spazio del Museo della Scienza di Milano.</p>
          <p>Qui è anche esposto un modello ligneo dell’osservatorio di Brera
          del 1764. Sembra una casa di bambole: immagino Schiaparelli che si muove al
          suo interno, anche se in quegli anni non era ancora nato!</p>
          <button className="btn btn-danger">CONTINUA</button>
        </>
      )}

      {(string === 'b_marge1a_room5') && (
        <p>Mentre passeggiavo per la sezione <strong>ascoltando il podcast del Museo «La scoperta del cielo, i marziani sono nati a Milano!»</strong> ho avuto l’illuminazione…ora è tutto chiaro!</p>
      )}

      {(string === 'b_marge1b_room5') && (
        <>
          <p>Ma allora… forse… un messaggio esiste davvero! Non ho immaginato tutto… o forse sì…</p>
          <p><strong>La password</strong> per proseguire è la risposta a questa domanda: <strong>«Le mappe di Schiaparelli negli anni ‘60 del XX secolo vennero utilizzate per pianificare le prime _____ _____ su Marte»</strong>.</p>
        </>
      )}
      {(string === 'b_marge1c_room5') && (
        <>
          <p>La risposta è  nel podcast ma… ci vorrebbe troppo tempo per ascoltarlo tutto ora! Ti do un indizio: I due barbuti <strong>uguali paiono</strong>, ma attento a quello che dà i numeri.</p>
          <p>Dove il numero cade sul <strong>dettaglio diverso, lì ascolterai.</strong></p>
        </>
      )}

      {(string === 'b_corriere_room5') && (
        <div style={{ width: '100%', height: '100%' }}>
          <PinchZoomPan position="center">
            <img src={require('../assets/images/domenica-corriere.jpg')} alt="Domenica del Corriere" />
          </PinchZoomPan>
        </div>
      )}


      {/* ************************** */ }
      {/* ********* ROOM 6 ********* */}
      {/* ************************** */ }

      {(string === 'b_intro_room6') && (
        <>
          <h3>20 Febbraio 2021 - NASA</h3>
          <p>Le missioni su Marte! Ecco dove devo guardare!<br />Dalla mia ultima ricerca sono trascorsi ben 3 lunghissimi anni, durante i quali ho cercato di dimenticare.<br />Ma ora non posso più voltarmi dall’altra parte e devo affrontare la realtà. La NASA è tornata su Marte: Mars 2020 è la missione americana che ha lo scopo di cercare segni di vita e raccogliere campioni di rocce da portare sulla Terra.</p>
          <p>Forse sono ancora in tempo per capire se Schiaparelli ha davvero un messaggio per noi. E se devo fermare la missione, forse sono ancora in tempo per fermarla!</p>
          <button className="btn btn-danger">CONTINUA</button>
        </>
      )}

      {(string === 'b_marge1a_room6') && (
        <p>Mentre studiavo il Rover «Perseverance» mi sono accorta di uno strano simbolo presente
        sul <strong>«trapano di carotaggio»</strong> che serve per estrarre dal suolo campioni di rocce.</p>
      )}

      {(string === 'b_marge2a_room6') && (
        <>
          <p>Nel dossier della NASA che documenta il rover, <strong>ho trovato anche questi due schemi che mi sono stati utilissimi per decifrare il codice segreto contenuto in quel simbolo sul trapano di carotaggio!</strong></p>
        </>
      )}



      {(string === 'b_cruciverba_room6') && (
        <div style={{ width: '100%', height: '100%' }}>
          <PinchZoomPan position="center">
            <img src={require('../assets/images/cruciverba.png')} alt="Domenica del Corriere" />
          </PinchZoomPan>
        </div>
      )}

      {(string === 'b_trapano_room6') && (
        <div style={{ width: '100%', height: '100%' }}>
          <PinchZoomPan position="center">
            <img src={require('../assets/images/trapano_map.png')} alt="Domenica del Corriere" />
          </PinchZoomPan>
        </div>
      )}

      {(string === 'b_lettera_room7') && (
        <div style={{ width: '100%', height: '100%' }}>
          <PinchZoomPan position="center">
            <img src={require('../assets/images/letteracompleta.jpg')} alt="Domenica del Corriere" />
          </PinchZoomPan>
        </div>
      )}
    </>
  )
}
